import { render, staticRenderFns } from "./OpMessageModal.vue?vue&type=template&id=b37bb030&scoped=true"
import script from "./OpMessageModal.vue?vue&type=script&lang=js"
export * from "./OpMessageModal.vue?vue&type=script&lang=js"
import style0 from "./OpMessageModal.vue?vue&type=style&index=0&id=b37bb030&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b37bb030",
  null
  
)

export default component.exports